if (!customElements.get('cart-drawer-recommendations')) {
  class CartDrawerRecommendations extends HTMLElement {
    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.recommendationsUrl = this.dataset.recommendationsUrl;
      this.cartAddUrl = this.dataset.cartAddUrl;

      this.fetchRecommendations();

      this.addEventListener('click', (event) => {
        const button = event.target.closest('.cart-drawer-recs__add');
        if (!button) return;
        event.preventDefault();
        this.addToCart(button.dataset.variantId, button);
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.fetchRecommendations();
        });
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    fetchRecommendations() {
      if (!this.cartUrl || !this.recommendationsUrl) return;

      fetch(this.cartUrl)
        .then((res) => res.json())
        .then((cart) => {
          if (!cart.items || cart.items.length === 0) {
            this.innerHTML = '';
            return;
          }

          const lastItem = cart.items[cart.items.length - 1];
          const cartProductIds = cart.items.map((item) => item.product_id);
          const url = `${this.recommendationsUrl}?product_id=${lastItem.product_id}&limit=12&intent=related`;

          return fetch(url)
            .then((res) => res.json())
            .then((data) => {
              const products = (data.products || [])
                .filter((product) => !cartProductIds.includes(product.id))
                .slice(0, 8);
              this.render(products);
            });
        })
        .catch(() => {
          // Recommendations are a non-essential enhancement: fail silently, never break the cart.
        });
    }

    render(products) {
      if (!products || products.length === 0) {
        this.innerHTML = '';
        return;
      }

      const cards = products.map((product) => this.renderCard(product)).join('');

      this.innerHTML = `
        <div class="cart-drawer-recs">
          <div class="cart-drawer-recs__header">
            <p class="cart-drawer-recs__heading caption-with-letter-spacing">Você também pode gostar</p>
            <div class="cart-drawer-recs__nav-group">
              <button type="button" class="cart-drawer-recs__nav cart-drawer-recs__nav--prev" aria-label="Produto anterior">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <button type="button" class="cart-drawer-recs__nav cart-drawer-recs__nav--next" aria-label="Próximo produto">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>
          </div>
          <div class="cart-drawer-recs__grid">${cards}</div>
        </div>
      `;

      this.setupCarousel();
      this.fitPriceSizes();
    }

    fitPriceSizes() {
      const prices = this.querySelectorAll('.cart-drawer-recs__price');
      prices.forEach((el) => {
        let size = 0.95;
        el.style.fontSize = '';
        while (el.scrollWidth > el.clientWidth && size > 0.65) {
          size -= 0.05;
          el.style.fontSize = size.toFixed(2) + 'rem';
        }
      });
    }

    setupCarousel() {
      const grid = this.querySelector('.cart-drawer-recs__grid');
      const prevBtn = this.querySelector('.cart-drawer-recs__nav--prev');
      const nextBtn = this.querySelector('.cart-drawer-recs__nav--next');
      if (!grid || !prevBtn || !nextBtn) return;

      const scrollAmount = 118;

      const updateButtons = () => {
        prevBtn.disabled = grid.scrollLeft <= 0;
        nextBtn.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
      };

      prevBtn.addEventListener('click', () => {
        grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
      grid.addEventListener('scroll', updateButtons);
      updateButtons();
    }

    renderCard(product) {
      const image = product.featured_image || (product.images && product.images[0]) || null;
      const price = this.formatMoney(product.price);
      const variant = product.variants && product.variants.length ? product.variants[0] : null;
      const canAddToCart = product.available !== false && variant && variant.available !== false;

      return `
        <div class="cart-drawer-recs__item">
          <a href="${product.url}" class="cart-drawer-recs__link">
            <div class="cart-drawer-recs__media">
              ${
                image
                  ? `<img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(product.title)}" loading="lazy" width="92" height="92">`
                  : ''
              }
            </div>
            <p class="cart-drawer-recs__title">${this.escapeHtml(product.title)}</p>
            <p class="cart-drawer-recs__price price">${price}</p>
          </a>
          ${
            canAddToCart
              ? `<button type="button" class="cart-drawer-recs__add" data-variant-id="${variant.id}" aria-label="Adicionar ${this.escapeHtml(product.title)} ao carrinho">Adicionar</button>`
              : ''
          }
        </div>
      `;
    }

    addToCart(variantId, button) {
      if (!variantId || !this.cartAddUrl || !button) return;

      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adicionando...';

      const cartDrawer = document.querySelector('cart-drawer');

      fetch(this.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : undefined,
          sections_url: window.location.pathname,
        }),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            // Sold out or another cart error: fail quietly, just restore the button.
            button.textContent = originalText;
            button.disabled = false;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-recommendations',
              productVariantId: variantId,
              cartData: response,
            });
          }

          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response);
          }
        })
        .catch(() => {
          button.textContent = originalText;
          button.disabled = false;
        });
    }

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    formatMoney(cents) {
      const value = (cents || 0) / 100;
      return (
        'R$ ' +
        value.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    }
  }

  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
